// Evolution chains keyed by species sprite key — the party model's
// `speciesId` (see src/engine/party.ts).
//
// Rationale: the chains are spelled out by SPECIES_DEX itself — each base
// species (ids 1-10) has a strictly higher-stat evolved form one dex slot up
// whose description names it ("Evolved from Salespup", "Evolved from Byte",
// ...). Only dex ids 1-12 own a unique sprite key (later entries reuse
// sprites, e.g. Recruitling also renders as "surggie_1"), so a sprite-keyed
// table can only address those five base→evolved pairs. Cratus ("surggie_11")
// and Huskii ("surggie_12") are legendaries and do not evolve.
//
// Levels mirror the numeric-id table in src/data/evolution.ts (still used by
// StatsScreen and the battle API) so both tables tell the same story.

export interface EvolutionEntry {
  /** Sprite key of the pre-evolution, e.g. "surggie_1". */
  from: string;
  /** Sprite key of the evolved form, e.g. "surggie_2". */
  to: string;
  /** Level at which the evolution triggers. */
  atLevel: number;
}

export const EVOLUTIONS: EvolutionEntry[] = [
  { from: "surggie_1", to: "surggie_2", atLevel: 16 }, // Salespup → Pitchdog (sales)
  { from: "surggie_3", to: "surggie_4", atLevel: 16 }, // Byte → Debuggor (tech)
  { from: "surggie_5", to: "surggie_6", atLevel: 18 }, // Qubit → Stonkzilla (finance)
  { from: "surggie_7", to: "surggie_8", atLevel: 14 }, // Vibecat → Brandlion (creative)
  { from: "surggie_9", to: "surggie_10", atLevel: 20 }, // Opster → Sysmonk (ops)
];

/** The evolution available to `spriteKey`, or undefined if it doesn't evolve. */
export function evolutionFor(spriteKey: string): EvolutionEntry | undefined {
  return EVOLUTIONS.find((e) => e.from === spriteKey);
}
